import React, { FC } from 'react';
import { Header } from '../Header/Header';
import { Navigation } from '../Navigation';
import { MenuPages } from '@types';
import styles from './StickyHeader.module.css';

export interface StickyHeaderProps {
    menuActivePage?: MenuPages;
}

export const StickyHeader: FC<StickyHeaderProps> = ({ menuActivePage }) => {
    return (
        <div id="sticky-header" className={`${styles['sticky-header']} sticky-top bg-light`} data-testid="sticky-header">
            <Header />
            <Navigation menuActivePage={menuActivePage} />
        </div>
    );
};
